import React from 'react';
import { DotsLoader } from '../../dots-loader/index.js';

var ChatLoader = function () {
    return (React.createElement("div", { className: 'saving for-chat for-round_loader' },
        React.createElement(DotsLoader, null)));
};

export { ChatLoader as default };
